import { GET_CITIES_REQUEST,
    GET_CITIES_SUCCESS,
    GET_CITIES_FAILURE } from '../../../actions/collaborations/constants';

const INITIAL_STATE = {
    all: [],
    fetching: false,
    error: null
}

export default function cities(state = INITIAL_STATE, action) {
    switch(action.type) {
        case  GET_CITIES_REQUEST:
            return {
                ...state,
                fetching: true
            }
        case  GET_CITIES_SUCCESS:
            return {
                ...state,
                all: action.payload,
                fetching: false
            }
        case  GET_CITIES_FAILURE:
            return {
                ...state,
                fetching: false,
                error: true,
                errorMsg: action.error
            }
        default:
            return state;
    }
}